module.exports = __webpack_public_path__ + "img/250.d31548b7.jpg";